export default __webpack_public_path__ + "static/media/Merriweather-Italic.4d1e263e.ttf";